import React from "react";
import { render, screen } from "@testing-library/react";
import { CanvasBuilderLivePreview } from "./CanvasBuilderLivePreview";

jest.mock("../components/canvasBuilder", () => {
  const React = require("react");
  return {
    CanvasRenderer: ({
      elements,
      mode,
      renderViewGrid,
      renderTimeline,
      renderDataWidget,
      renderEmbeddedCanvas,
    }: any) => (
      <div data-testid="canvas-renderer" data-mode={mode}>
        {renderViewGrid(elements[0])}
        {renderTimeline(elements[1])}
        {renderDataWidget(elements[2])}
        {renderEmbeddedCanvas(elements[3])}
      </div>
    ),
    CanvasViewGridRenderer: ({ element }: any) =>
      React.createElement(
        "div",
        { "data-testid": "runtime-view-grid" },
        element.id,
      ),
    CanvasTimelineRenderer: ({ element }: any) =>
      React.createElement(
        "div",
        { "data-testid": "runtime-timeline" },
        element.id,
      ),
    CanvasDataWidgetRenderer: ({ element }: any) =>
      React.createElement(
        "div",
        { "data-testid": "runtime-data-widget" },
        element.id,
      ),
    EmbeddedCanvasRenderer: ({
      element,
      allowCreate,
      allowEdit,
      allowDelete,
    }: any) =>
      React.createElement(
        "div",
        {
          "data-testid": "runtime-embedded-canvas",
          "data-write-access": `${allowCreate}:${allowEdit}:${allowDelete}`,
        },
        element.id,
      ),
  };
});

jest.mock("../theme/CanvasThemeScope", () => ({
  CanvasThemeScope: ({ children }: { children: React.ReactNode }) => children,
}));

const element = (id: string, type: string) => ({
  id,
  type,
  props: { data_source_alias: "main", allow_create: true, allow_edit: true },
  gridColumn: 1,
  gridRow: 1,
  columnSpan: 4,
  rowSpan: 2,
});

describe("CanvasBuilderLivePreview", () => {
  it("uses the runtime renderer and passes the authenticated widget renderers", () => {
    render(
      <CanvasBuilderLivePreview
        elements={
          [
            element("grid-1", "view_grid"),
            element("timeline-1", "timeline"),
            element("kanban-1", "kanban"),
            element("embedded-1", "embedded_canvas"),
          ] as any
        }
        config={{ columns: 12, rowHeight: 60, gap: 8, minRows: 10 }}
        workspaceId="workspace-1"
        canvasId="canvas-1"
        dataSources={[
          {
            id: "main",
            name: "main",
            type: "view",
            view_id: 42,
            config: {},
          },
        ]}
        title="Preview"
        breakpoint="desktop"
      />,
    );

    expect(
      screen.getByTestId("canvas-renderer").getAttribute("data-mode"),
    ).toBe("runtime");
    expect(screen.getByTestId("runtime-view-grid").textContent).toBe("grid-1");
    expect(screen.getByTestId("runtime-timeline").textContent).toBe(
      "timeline-1",
    );
    expect(screen.getByTestId("runtime-data-widget").textContent).toBe(
      "kanban-1",
    );
    expect(screen.getByTestId("runtime-embedded-canvas").textContent).toBe(
      "embedded-1",
    );
    expect(
      screen
        .getByTestId("runtime-embedded-canvas")
        .getAttribute("data-write-access"),
    ).toBe("false:false:false");
  });
});
